import React, { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {SocketContext} from 'context/socket';

import { Modal } from 'react-bootstrap';
import Image from '../../statics/updating-content.png';
import { ProgressBar } from 'react-bootstrap';

import './styles.scss';

const ModalUpdatingContent = (props) => {
    const { t } = useTranslation()
    const { info } = props;
    const language = localStorage.getItem('language')
    const socket = useContext(SocketContext);

    useEffect(() => {
        if (info && Number(info.progress) === 100) {
            socket.emit('rcs-locked-on-updating-content-stop');
            socket.emit('rcs-info-updating-content-check');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.info])

    return (
        <Modal
            size="lg"
            show
            aria-labelledby="example-modal-sizes-title-lg"
        >
            <Modal.Body className="update-content-modal-customer-container">
                <div className="upper-part">
                    <div className="title">{t('updatingContentModal.title')}</div>
                    <div className="message1">{t('updatingContentModal.message1')}</div>
                    <div className="message2">{t('updatingContentModal.message2')}</div>
                </div>
                <img src={Image} className="image" alt="updating content"></img>
                { info && info.progress && (
                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <div className="progress-text">{`${t('updatingContentModal.updatingContent')} ${info.progress}%`}</div>
                        <ProgressBar now={info.progress}/>
                    </div>
                )}
                { info && info[`error_${language}`] &&
                    <div className="error">{`Error: ${info[`error_${language}`]}`}</div>
                }
            </Modal.Body>
        </Modal>
    );
}

export default ModalUpdatingContent;